import { render, staticRenderFns } from "./chooseDorm.vue?vue&type=template&id=83ebe9ae&scoped=true"
import script from "./chooseDorm.vue?vue&type=script&lang=js"
export * from "./chooseDorm.vue?vue&type=script&lang=js"
import style0 from "./chooseDorm.vue?vue&type=style&index=0&id=83ebe9ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ebe9ae",
  null
  
)

export default component.exports